<template>
  <div class="inline-flex">
    <svg
      class="shrink-0"
      width="20"
      height="39"
      viewBox="0 0 20 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0808 0C16.5161 0 15.0277 0.67567 13.9977 1.8535L1.34101 16.3268C-0.480869 18.4102 -0.442043 21.5311 1.4311 23.5685L14.0068 37.247C15.034 38.3642 16.4822 39 17.9998 39H20.2725V0L18.0808 0ZM11.361 23.4843C13.5614 23.2888 15.1868 21.3465 14.9912 19.146C14.7957 16.9455 12.8534 15.3202 10.6529 15.5157C8.45245 15.7113 6.82711 17.6536 7.02263 19.8541C7.21815 22.0545 9.16049 23.6799 11.361 23.4843Z"
        class="fill-danger"
      />
    </svg>

    <span
      class="bg-danger text-danger-contrast -ml-[1px] flex select-none items-center whitespace-nowrap rounded-r-md pl-2 pr-3 text-xs font-semibold shadow-md"
      ><slot
    /></span>
  </div>
</template>
